import { render, staticRenderFns } from "./RegisterOnlineGrocery.vue?vue&type=template&id=53e7871e&"
import script from "./RegisterOnlineGrocery.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlineGrocery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports